import { useState, useEffect } from 'react';
import { COUNTRIES_DATA } from '../data/countriesData';

export const useCountries = () => {
    const [countries, setCountries] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setCountries(COUNTRIES_DATA);
        setIsLoading(false);
    }, []);

    return {
        countries,
        isLoading,
        fetchError: false,
        refetch: () => { }
    };
};